/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PGAModelBuilderFeatureOutputQueryVariables = {|
  featureID: string
|};
export type PGAModelBuilderFeatureOutputQueryResponse = {|
  +outputForCalcFeature: ?$ReadOnlyArray<?{|
    +player: {|
      +id: string,
      +nameShort: ?string,
      +firstName: ?string,
      +lastName: ?string,
      +nameDisplay: string,
      +dkPlayer: ?{|
        +id: string
      |},
    |},
    +num: ?number,
    +stat: ?any,
    +diff: ?any,
    +zscore: ?any,
    +modelScore: ?any,
    +orderedTeeTimesUsed: ?$ReadOnlyArray<?{|
      +eventPlayer: ?{|
        +event: {|
          +pgaTourId: string,
          +season: {|
            +queryValue: string
          |},
          +tournament: {|
            +officialName: string
          |},
        |}
      |},
      +roundNumber: number,
    |}>,
  |}>
|};
export type PGAModelBuilderFeatureOutputQuery = {|
  variables: PGAModelBuilderFeatureOutputQueryVariables,
  response: PGAModelBuilderFeatureOutputQueryResponse,
|};
*/


/*
query PGAModelBuilderFeatureOutputQuery(
  $featureID: ID!
) {
  outputForCalcFeature(featureId: $featureID) {
    player {
      id
      nameShort
      firstName
      lastName
      nameDisplay
      dkPlayer {
        id
      }
    }
    num
    stat
    diff
    zscore
    modelScore
    orderedTeeTimesUsed {
      eventPlayer {
        event {
          pgaTourId
          season {
            queryValue
            id
          }
          tournament {
            officialName
            id
          }
          id
        }
        id
      }
      roundNumber
      id
    }
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "featureID"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "featureId",
    "variableName": "featureID"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "PGATourPlayerType",
  "kind": "LinkedField",
  "name": "player",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameShort",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameDisplay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PlayerType",
      "kind": "LinkedField",
      "name": "dkPlayer",
      "plural": false,
      "selections": [
        (v2/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "num",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stat",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "diff",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zscore",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modelScore",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pgaTourId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "queryValue",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "officialName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roundNumber",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PGAModelBuilderFeatureOutputQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PGATourModelCalcFeatureOutputType",
        "kind": "LinkedField",
        "name": "outputForCalcFeature",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourEventPlayerTeeTimeType",
            "kind": "LinkedField",
            "name": "orderedTeeTimesUsed",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PGATourEventPlayerType",
                "kind": "LinkedField",
                "name": "eventPlayer",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PGATourEventType",
                    "kind": "LinkedField",
                    "name": "event",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PGATourSeasonType",
                        "kind": "LinkedField",
                        "name": "season",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PGATourTournamentType",
                        "kind": "LinkedField",
                        "name": "tournament",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v12/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PGAModelBuilderFeatureOutputQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PGATourModelCalcFeatureOutputType",
        "kind": "LinkedField",
        "name": "outputForCalcFeature",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourEventPlayerTeeTimeType",
            "kind": "LinkedField",
            "name": "orderedTeeTimesUsed",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PGATourEventPlayerType",
                "kind": "LinkedField",
                "name": "eventPlayer",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PGATourEventType",
                    "kind": "LinkedField",
                    "name": "event",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PGATourSeasonType",
                        "kind": "LinkedField",
                        "name": "season",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PGATourTournamentType",
                        "kind": "LinkedField",
                        "name": "tournament",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v12/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "2e0e82b1924ea46a9a40e2d2c87b763f",
    "id": null,
    "metadata": {},
    "name": "PGAModelBuilderFeatureOutputQuery",
    "operationKind": "query",
    "text": "query PGAModelBuilderFeatureOutputQuery(\n  $featureID: ID!\n) {\n  outputForCalcFeature(featureId: $featureID) {\n    player {\n      id\n      nameShort\n      firstName\n      lastName\n      nameDisplay\n      dkPlayer {\n        id\n      }\n    }\n    num\n    stat\n    diff\n    zscore\n    modelScore\n    orderedTeeTimesUsed {\n      eventPlayer {\n        event {\n          pgaTourId\n          season {\n            queryValue\n            id\n          }\n          tournament {\n            officialName\n            id\n          }\n          id\n        }\n        id\n      }\n      roundNumber\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3d5cbe915739f1884be6d70d6d8882f4';

module.exports = node;
